import SkeletonAssigner from "../../output/assets/skeletons/skeleton-assigner.js";

class ThreeSkeletonAssigner extends SkeletonAssigner {
    link(object, { bindMatrix, skeleton }) {
        object.bind(skeleton, bindMatrix);
    }

    unlink(object, { bindMatrix, skeleton }) {}
}

export default ThreeSkeletonAssigner;
